@if (icon.length > 0) {
	<button mat-icon-button class="icon-button" (click)="onClick()">
		<mat-icon [fontIcon]="icon" />
	</button>
}
